import { get } from '@nbx/frontend-helpers/fetch-api';
import { context } from '@nbx/frontend-helpers/auth';

let baseUrl = 'cryptobank';

const NBXWithdrawals = {
  init: config => ({ baseUrl } = config),

  getWithdrawals: ({ asset }) =>
    context
      .account()
      .then(account => get(`${baseUrl}/accounts/${account.id}/assets/${asset}/withdrawals`, account))
      .then(response => response.withdrawals)
};

export default NBXWithdrawals;
